/* eslint-disable consistent-return */
import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@contexts/authContext';

function ProtectedRoute({ children, loggedOnly = true }) {
  const { auth } = useAuth();
  const location = useLocation();

  if (auth.isAuthenticated === null) {
    console.warn('Auth context is still loading...');
    return;
  }

  if (!auth.isAuthenticated && loggedOnly) {
    return <Navigate to='/login' state={{ from: location }} />;
  }

  if (auth.isAuthenticated && !loggedOnly) {
    const redirAfterLogin = localStorage.getItem('REDIRECT_AFTER_LOGIN');
    if (redirAfterLogin) {
      localStorage.removeItem('REDIRECT_AFTER_LOGIN');
      return <Navigate to={redirAfterLogin} />;
    }
    return <Navigate to='/' />;
  }

  return children;
}

export default ProtectedRoute;
